import { ChevronsUpDown, Printer, SquarePen, Trash2 } from 'lucide-react';
import React, { useState } from 'react';
import Badge from '../UI/Badge';
import { exchangeDate, Gender, usPhoneFormat } from '../../helpers';
import DeleteModal from '../Modal/DeleteModal';
import Skeleton from 'react-loading-skeleton';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function EasyReferralDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    printEasyReferral = () => {},
    setEditReferralData = () => {},
    setEditReferral = () => {},
    setViewReferralId = () => {},
    setViewReferral = () => {},
    handleDeleteRecord = () => {},
    referType = "",
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };

  const handleEditData = (data)  => {
    setEditReferralData(data);
    setEditReferral(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleViewReferralData = (id)  => {
    setViewReferralId(id);
    setViewReferral(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("dos");
                  }}
                  className={
                    orderBy === "dos" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    DOS <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                Referred {referType === 'outgoing' ? 'To' : 'From'}
              </th>
              <th>Patient Info</th>
              <th>Insurance</th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("patient_conditon");
                  }}
                  className={
                    orderBy === "patient_conditon" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Condition <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("status");
                  }}
                  className={
                    orderBy === "status" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Status <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody className="docpro_vertical_align">
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td className='pointer' onClick={() => handleViewReferralData(item?.id)}>{exchangeDate(item?.dos)}</td>
                    <td className='pointer' onClick={() => handleViewReferralData(item?.id)}>
                      <div className="docpro_table_info_list docpro_table_info_list_lg">
                        <p className="docpro_mb_0">
                          <b>Practice Name:</b> {referType === 'outgoing' ? item?.provider_organization_name : item?.sender_organization_name}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Phone:</b> {referType === 'outgoing' ? (item?.provider_business_practice_location_address_telephone_number ? usPhoneFormat(item?.provider_business_practice_location_address_telephone_number) : "") : (item?.sender_business_practice_location_address_telephone_number ? usPhoneFormat(item?.sender_business_practice_location_address_telephone_number) : "")}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Address:</b> {referType === 'outgoing' ? item?.provider_address : item?.sender_address}
                        </p>
                      </div>
                    </td>
                    <td className='pointer' onClick={() => handleViewReferralData(item?.id)}>
                      <div>
                        <p className="docpro_mb_0">
                          <b>Name: </b> {item?.last_name}{' '}{item?.first_name}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Birth: </b> {exchangeDate(item?.dob)}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Gender: </b> {Gender(item?.sex)}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Phone: </b> {usPhoneFormat(item?.phone)}
                        </p>
                      </div>
                    </td>
                    <td className='pointer' onClick={() => handleViewReferralData(item?.id)}>
                      <div>
                        <p>
                          <b>Name: </b> {item?.insurance_name}
                        </p>
                        <p>
                          <b>ID: </b> {item?.insurance_code}
                        </p>
                      </div>
                    </td>
                    <td className='pointer' onClick={() => handleViewReferralData(item?.id)}>{item?.patient_conditon}</td>
                    <td className='pointer' onClick={() => handleViewReferralData(item?.id)}>
                      {item?.status === "Pending" && (
                        <Badge color="orange" square>{item?.status}</Badge>
                      )}
                      {item?.status === "Confirm" && (
                        <Badge color="indigo" square>{item?.status}</Badge>
                      )}
                      {item?.status === "Completed" && (
                        <Badge color="green" square>{item?.status}</Badge>
                      )}
                    </td>
                    <td>
                      <div className="docpro_icon_btns">
                        {(reloadDataFilter?.refer_type === 'outgoing' && item?.status !== "Completed") && (
                          <button
                            type="button"
                            className="docpro_icon_btn"
                            onClick={() => handleEditData(item)}
                          >
                            <SquarePen width={18} height={18} />
                            <span className="docpro_tip">Edit Referral</span>
                          </button>
                        )}

                        <button 
                          type="button"
                          className="docpro_icon_btn last_btn_tip"
                          onClick={() => printEasyReferral(item.id)}
                        >
                          <Printer width={18} height={18} />
                          <span className="docpro_tip">Print Referral</span>
                        </button>

                        {(reloadDataFilter?.refer_type === 'outgoing' && item?.status !== "Completed") && (
                          <button
                            type="button"
                            className="docpro_icon_btn docpro_icon_btn_red last_btn_tip"
                            onClick={() => {
                              setDeleteRecord(item);
                              setActiveDeleteModal(true);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <Trash2 width={18} height={18} />
                            <span className="docpro_tip">Delete</span>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px", verticalAlign: "middle" }} colSpan="7">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name="this referral"
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
